const ERROR_MESSAGE = 'Missing Crypto API'

const getRandomValues = () => {
  if (!window || !window.crypto) throw new Error(ERROR_MESSAGE)

  const randomBuffer = new Uint32Array(1)
  return window.crypto.getRandomValues(randomBuffer)
}

export const getRandomNumber = (min: number, max: number) => {
  const randomBuffer = getRandomValues()
  const randomNumber = randomBuffer[0] / (0xffffffff + 1)
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(randomNumber * (max - min + 1)) + min
}

export const getRandomValueFromArray = <T>(array?: T[]) => {
  if (!array?.length) return

  const randomBuffer = getRandomValues()
  const randomIndex = randomBuffer[0] % array.length
  return array[randomIndex]
}
